import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface PaginationState {
	[entity: string]: number;
}

const initialState: PaginationState = {};

/*
  NOT IN USE
  this slice will be used to implement auto-reauth when token expires
*/
const paginationSlice = createSlice({
	name: 'pagination',
	initialState,
	reducers: {
		setPageNumber(state, action: PayloadAction<{ entity: string; value: number }>) {
			state[action.payload.entity] = action.payload.value;
		},
	},
});

export const { setPageNumber } = paginationSlice.actions;
export default paginationSlice.reducer;
